import { PatientProfile } from '../api/services/orders/types.ts'
import { DEVELOPMENT_HOSTNAME, PRODUCTION_HOSTNAME } from './constants.ts'

export const getPatientProfileDetails = (
  patienProfile: PatientProfile | null | undefined
) => {
  let returnData: {
    first_name: string
    last_name: string
    isFromPD3: boolean
    pd3_uuid: string
  } = {
    first_name: patienProfile ? patienProfile.first_name : 'Brak danych',
    last_name: patienProfile ? patienProfile.last_name : '',
    isFromPD3: false,
    pd3_uuid: ''
  }

  if (patienProfile && Object.keys(patienProfile.cached_data).length > 0) {
    returnData.first_name = patienProfile.cached_data.first_name
    returnData.last_name = patienProfile.cached_data.last_name
    returnData.isFromPD3 = true
    returnData.pd3_uuid = patienProfile.pd3_uuid
  }

  return returnData
}

export const linkToProfilePD3 = (uuid: string) => {
  const path = `/#/patients/patient/${uuid}/dashboard/main`
  if (process.env.NODE_ENV === 'development') {
    return `${DEVELOPMENT_HOSTNAME}${path}`
  } else {
    return `${PRODUCTION_HOSTNAME}${path}`
  }
}
